export default "__VITE_ASSET__38b67c6a__"